exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current[data-v-201a5249]{font-weight:700;font-size:1.625rem;color:#042d68}.current[data-v-201a5249],label[data-v-201a5249]{text-align:center}label[data-v-201a5249]{color:#8a90a3;display:block;font-size:.9375rem}button[data-v-201a5249]{border:1px solid #042d68;background:#fff;border-radius:5px;width:2.5rem;height:2.5rem;font-weight:400;font-size:1.5rem;color:#042d68;transition:all .3s ease}button[data-v-201a5249]:hover{background:#042d68;border-color:#042d68;color:#fff}", ""]);

// exports
